// src/pages/BeersPage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/layout/Header';
import beersBackground from '../assets/images/beers-background.jpg';
import '../styles/beers.css';
import SEOHead from '../components/SEO/SEOHead';

const BeersPage = () => {
  const navigate = useNavigate();

  return (
    <div className="beers-page" style={{ backgroundImage: `url(${beersBackground})` }}>
    <SEOHead
      title="Bières à pression"
      description="Bières à la pression livrées pour vos événements à Douala."
      canonical="https://bccv.online/beers"
    />
      <Header 
        title="Bières" 
        showBackButton={true} 
        onBackClick={() => navigate('/prototype-categories')}
      />
      
      <div className="beers-content">
        <div className="beers-content-overlay">
          <div className="beers-icon animate-float">
            <svg viewBox="0 0 24 24" className="w-full h-full" fill="currentColor">
              <path d="M5,12V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V12L5,12M5,10H19V7A2,2 0 0,0 17,5H7A2,2 0 0,0 5,7V10M9,7H10.5V9.5H9V7M11.5,7H13V9.5H11.5V7M14,7H15.5V9.5H14V7M9,16A1,1 0 0,1 8,17A1,1 0 0,1 7,16A1,1 0 0,1 8,15A1,1 0 0,1 9,16M12,15A1,1 0 0,1 13,16A1,1 0 0,1 12,17A1,1 0 0,1 11,16A1,1 0 0,1 12,15M16,15A1,1 0 0,1 17,16A1,1 0 0,1 16,17A1,1 0 0,1 15,16A1,1 0 0,1 16,15Z" />
            </svg>
          </div>
          
          <h2 className="beers-title">Bientôt disponible !</h2>
          
          <p className="beers-description">
            Notre gamme de bières en bouteilles et canettes sera bientôt disponible. 
            Découvrez prochainement une sélection variée de bières locales et internationales, 
            des blondes légères aux brunes corsées, pour tous les goûts.
          </p>
          
          <button 
            onClick={() => navigate('/prototype-categories')}
            className="beers-button"
          >
            <svg className="beers-button-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            Retour aux options
          </button>
        </div>
      </div>
    </div>
  );
};

export default BeersPage;